import { COORDINATION_TYPE } from 'constants/Actions/CoordinationTypes';

// Estado inicial del reducer
const aInitialState = {
    aAllCoordinationTypes: [],
    aActiveCoordinationTypes: [],
    oCoordinationType: null,

    bIsSuccess: false,
    bIsError: false,
}
/**
 * Reducer que será utilizado para controlar los datos referidos a los tipos de coordinación almacenados en el sistema.
 * 
 * @param {Array} aState Estado, si no recibe datos se setea el estado inicial
 * @param {object} oAction Action que es ejecutada
 * 
 * @returns {Array} Retorna un array que sera seteado en el estado del reducer
 * 
 * @author Matías Rivero
 */
export const CoordinationTypeReducer = (aState = aInitialState, oAction) => {
    switch (oAction.type) {        
        case COORDINATION_TYPE.GET_ALL:
            return { ...aState, aAllCoordinationTypes: oAction.data };
        case COORDINATION_TYPE.GET_ACTIVE:
            return { ...aState, aActiveCoordinationTypes: oAction.data };
        case COORDINATION_TYPE.FIND:
            return { ...aState, oCoordinationType: oAction.data };
        case COORDINATION_TYPE.SUCCESS:
            return { ...aState, bIsSuccess: true };
        case COORDINATION_TYPE.ERROR:
            return { ...aState, bIsError: true };
        case COORDINATION_TYPE.CLEAN:
            return { ...aState, bIsSuccess: false, bIsError: false, oCoordinationType: null };
        default:
            return aState;
    }
}
